<template>
    <div class="px-1">
      <div class="dataPartoTitle mt-1">Cargar datos Parto</div>
      <div>
        <validation-observer ref="registerForm">
          <b-form
            class="auth-register-form mt-2"
            @submit.prevent="validationForm"
          >
            <div class="d-flex">
              <b-form-group class=" mr-1">
                Fecha
                <flat-pickr v-model="reproductive.date" class="form-control" />
              </b-form-group>
              <b-form-group
                label="Tipo de parto"
                label-for="deliveryType"
                class="flex-fill"
              >
                <v-select
                  id="deliveryType"
                  :options="deliveryTypeOptions"
                  v-model="reproductive.delivery_type"
                  label="text"
                />
              </b-form-group>
              
            </div>
            <div class="flex">
              <b-form-group
              label="Seleccionar Vaca (hembras)"
              label-for="selFemale"
              class="selFemale"
              >
                <v-select
                  id="selFemale"
                  placeholder="Buscar y seleccionar Animal"
                  v-model="femaleAnimal"
                  :options="animalsOptionsFem"
                  :values="animalsOptionsFem.value"
                  label="text"
                />
              </b-form-group>
            </div>
            <div class="d-flex">
              <div>¿Se presentó aborto?:</div> 
                <div class="d-flex justify-content-center ml-2">
                  <div class="flex-column pt-0 mr-2">
                    No
                  </div>
                  <div class="align-self-end">
                    <b-form-checkbox
                      checked="false"
                      button-variant="#D7B92C"
                      class="custom-control-warning"
                      name="check-button"
                      switch
                    />
                  </div>
                  <div class="flex-column">
                      Si
                  </div>
                </div>
            </div>
            <div class="d-table">
            <div class="dataSecondTitles">Datos del nuevo ternero (a):</div>
              <b-form-group label="Nombre " label-for="name" class="pr-1 name">
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="new_animal.name"
                    :state="errors.length > 0 ? false : null"
                    name="name"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <div class="d-flex justify-content-around">
                <b-form-group
                  label="Numero "
                  label-for="number"
                  class="pr-1 number"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="number"
                    rules="required"
                  >
                    <b-form-input
                      id="number"
                      v-model="new_animal.number"
                      :state="errors.length > 0 ? false : null"
                      name="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  label="Peso "
                  label-for="weight"
                  class="pr-1 weight"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="weight"
                    rules="required"
                  >
                    <b-form-input
                      id="weight"
                      v-model="new_animal.weight"
                      :state="errors.length > 0 ? false : null"
                      name="weight"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>
              <div class="d-flex justify-content-center">
                <div class="flex-column pt-0 mr-2">
                  Macho
                </div>
                <div class="align-self-end mr-">
                  <b-form-checkbox
                    checked="true"
                    button-variant="#D7B92C"
                    class="custom-control-warning"
                    name="check-button"
                    v-model="new_animal.sex"
                    switch
                  />
                </div>
                <div class="flex-column">
                  Hembra
                </div>
              </div>
            </div>
            <b-form-group
              label="Observaciones (asistido, dificil, etc) "
              label-for="observation"
              class="observations"
            >
              <validation-provider
                #default="{ errors }"
                name="observation"
                rules="required"
              >
                <b-form-input
                  id="observation"
                  v-model="reproductive.diagnosis"
                  :state="errors.length > 0 ? false : null"
                  name="observation"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-form>
        </validation-observer>
  
        <div class=" additives">
          <div class="d-flex">
            <div>Subir archivo o foto:</div>
            <div class="d-flex align-items-center justify-content-center">
              <b-img src="@/assets/images/ganImage/UpoladImage.png"></b-img>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-center">
          <b-button
            type="submit"  v-on:click="insertDelivery"
            class="bg-primary mt-1 d-flex "
          >
            <div class="ml-5">Incluir Evento</div>
            <div class="pl-3" style="color: #d7b92c">
              <feather-icon icon="PlusIcon" size="18" />
            </div>
          </b-button>
      </div>
        </div>
      </div>
      <ControlMenu />
    </div>
  </template>
  
  <script>
  import ControlMenu from "@/components/ControlMenu.vue";
  import vSelect from "vue-select";
  import "vue-select/dist/vue-select.css";
  import { ValidationProvider, ValidationObserver } from "vee-validate";
  import {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BImg,
    BButton,
    BFormCheckbox,
  } from "bootstrap-vue";
  import { required } from "@validations";
  import flatPickr from "vue-flatpickr-component";
  
  let apiURL='https://927d1d30.us-south.apigw.appdomain.cloud/ganapp/api/';
  let self= this;
  
  export default {
    components: {
      ControlMenu,
      flatPickr,
      BFormGroup,
      ValidationProvider,
      ValidationObserver,
      BFormGroup,
      BFormInput,
      BForm,
      required,
      vSelect,
      BImg,
      BButton,
      BFormCheckbox,
    },
    data() {
      return {
        date: null,
        dateDefault: null,
        timePicker: null,
        datetime: null,
        multiDate: null,
        deliveryTypeOptions:[],
        deliveryType:'',
        rangeDate: null,
        humanDate: null,
        disableDate: null,
        observation:'',
        inlineDate: null,
        veterinarian: "",
        femaleAnimal: null,
        animalsOptionsFem:[],
        new_animal:{
          name:"",
          number:0,
          weight:0,
          sex:1,
          farm_id:localStorage.getItem('currentFarm'),
          birthdate:today,
        },
        reproductive:{
          animal_id:0,
          male_id:59,
          type:4,
          condition_id:1,
          date:null,
          veterinarian:"",
          diagnosis:"",
          status:1
        }
      };
    },
  
    methods: {
      async fetchDeliveryType(config) {
        fetch(apiURL+"list/birth_types", config)
        .then(response => response.json())
        .then(result => {
            this.deliveryTypeOptions = result.birth_types.map(item => {return {text:item.name, value:item.id}})
        })
      },
  
      async fetchAnimalsFem(config){
        let farmId= localStorage.getItem('currentFarm');
        fetch(apiURL+"list/animals?farm_id="+farmId+"&sex=1", config)
        .then(response => response.json())
        .then(result => {
            console.log(result.animals);
            this.animalsOptionsFem = result.animals.map(item => {return {value:item.id,text:item.number+ ' '+item.name}})
        })
      },
  
      insertDelivery() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.reproductive.animal_id= this.femaleAnimal.value;
        this.new_animal.birthdate= this.reproductive.date;
        this.$http.post("add/reproductive_records", this.reproductive, config).then(()=>{
          this.$http.post("add/animals", this.new_animal, config).then(()=>{
            this.$swal({
              title: 'Registro de Animal',
              text: 'Se insertó animal de manera satisfactoria',
              type: 'success',
              icon:'success',
              showCancelButton: false,
              confirmButtonColor:'#5E8F23',
              showCloseButton: true,
              showLoaderOnConfirm: false  
            }).then(function(){
                self.$router.replace({name:'basic-animals'});
            });
          })
        }).catch(error => {
          console.log(error)
        });
      },
  
    },
  
    created() {
      const token = localStorage.getItem("accessToken");
      const config = {headers: {"X-Authorization": `Bearer ${token}`}};
      this.fetchDeliveryType(config);
      this.fetchAnimalsFem(config);
    }
  };
  </script>
  
  <style lang="scss">
  .dataPartoTitle {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #5e5873;
  }
  
  .dataSecondTitles {
    font-weight: 600;
    font-size: 24px;
    color: #5e5873;
  }
  
  .datePickers {
    background: #ffffff;
    border-radius: 5px;
  }
  .selFemales {
  
    font-weight: 400;
    font-size: 12px;
    color: #6e6b7b;
  }
  
  .uploadImages {
  
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #6e6b7b;
  }
  .additives {
  
    font-weight: 400;
    font-size: 12px;
    color: #6e6b7b;
  }
  
  
  @import "@core/scss/vue/libs/vue-flatpicker.scss";
  @import "@core/scss/vue/pages/page-auth.scss";
  </style>
  